import type { AgentApiCompaniesSummaryItem } from '@/types/serializers';
import { useInfiniteQuery } from '@tanstack/react-query';

type SummaryCompaniesResponse = {
  records: AgentApiCompaniesSummaryItem[];
  total_count: number;
  total_pages: number;
  current_page: number;
  next_page: number | null;
  prev_page: number | null;
  per_page: number;
  is_first_page: boolean;
  is_last_page: boolean;
};

export default function useFetchSummaryCompanies(query: string = '', includeSharedJobPost = false) {
  return useInfiniteQuery({
    queryKey: ['/agent/api/summary_companies', query, includeSharedJobPost],
    queryFn: async ({ pageParam = 1 }) => {
      const params = new URLSearchParams();
      if (query) params.set('query', query);
      if (includeSharedJobPost) params.set('include_shared_job_post', 'true');
      params.set('page', String(pageParam));
      const response = await fetch(`/agent/api/summary_companies?${params}`);
      const data: SummaryCompaniesResponse = await response.json();
      return data;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.is_last_page) return undefined;
      return lastPage.current_page + 1;
    },
    initialPageParam: 1,
  });
}
